import { baseConfig } from "config";
import Cookies from "js-cookie";

const ONE_HOUR_IN_MILLIS = 60 * 60 * 1000;

const CookieHelper = {
	setCookies(name: string, value: any, expireHours = null) {
		const cookieConfig: Record<string, any> = {
			secure: true,
			domain: baseConfig.baseURLDomain
		};
		if (expireHours) {
			const expireInMillis = expireHours * ONE_HOUR_IN_MILLIS;
			const expirationDate = new Date();
			expirationDate.setTime(expirationDate.getTime() + expireInMillis);
			cookieConfig.expires = expirationDate;
		}

		Cookies.set(name, value, cookieConfig);
	},

	getCookies(name: string) {
		return Cookies.get(name);
	},

	removeCookie(name: string, options?: Record<string, string>) {
		Cookies.remove(name, options);
	}
};

export default CookieHelper;
